module.exports = __webpack_public_path__ + "static/media/work-teaser1.e1f7362e.jpg";